import React, { useState, useRef, useEffect } from "react";
import { Container, SelectedValue, DropdownList, ListItem } from "./styles";
import { getActiveLanguage } from "../../utils/getActiveLanguage";

interface ILanguageOption {
  code: string;
  label: string;
  emoji: string;
}

const languages: ILanguageOption[] = [
  { code: "pt-BR", label: "PT", emoji: "https://flagcdn.com/w20/br.png" },
  { code: "es", label: "ES", emoji: "https://flagcdn.com/w20/es.png" },
  { code: "en", label: "EN", emoji: "https://flagcdn.com/w20/gb.png" },
  { code: "fr", label: "FR", emoji: "https://flagcdn.com/w20/fr.png" },
];

interface ILanguageSelectorProps {
  variant?: "transparent" | "solid";
  position?: "top" | "bottom";
}

export function LanguageSelector({ variant = "solid", position = "bottom" }: ILanguageSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  
  const currentLang = getActiveLanguage();
  const selectedOption = languages.find(l => l.code === currentLang) || languages[0];

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function handleLanguageSelect(code: string) {
    if (code !== currentLang) {
      window.localStorage.setItem("i18nextLng", code);
      window.location.reload();
    }
    setIsOpen(false);
  }

  return (
    <Container variant={variant} ref={containerRef}>
      <SelectedValue onClick={() => setIsOpen(!isOpen)}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {selectedOption.label} 
          <img src={selectedOption.emoji} width="16" alt="flag" style={{ borderRadius: '2px' }} />
        </span>
        <span style={{ fontSize: '10px' }}>▼</span>
      </SelectedValue>
      
      <DropdownList isOpen={isOpen} position={position}>
        {languages.map((lang) => (
          <ListItem 
            key={lang.code} 
            isSelected={lang.code === currentLang}
            onClick={() => handleLanguageSelect(lang.code)}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {lang.label} 
              <img src={lang.emoji} width="16" alt="flag" style={{ borderRadius: '2px' }} />
            </span>
          </ListItem>
        ))}
      </DropdownList>
    </Container>
  );
}
